import { createClient } from './_client';
import * as _events from './events';
import * as _locations from './locations';
import * as _stats from './stats';
import * as _public from './public';
import * as _records from './records';
import * as _reports from './reports';
import * as _errorsModule from './_errors';
export var DownloadsApi;
(function (DownloadsApi) {
    DownloadsApi.Events = _events.Events;
    DownloadsApi.Locations = _locations.Locations;
    DownloadsApi.Stats = _stats.Stats;
    DownloadsApi.Public = _public.Public;
    DownloadsApi.Records = _records.Records;
    DownloadsApi.Reports = _reports.Reports;
    DownloadsApi.Errors = _errorsModule.DownloadsApiErrors;
})(DownloadsApi || (DownloadsApi = {}));
export function createDownloadsApiBindings(client) {
    return {
        events: _events.Events.bindScope(client),
        locations: _locations.Locations.bindScope(client),
        stats: _stats.Stats.bindScope(client),
        public: _public.Public.bindScope(client),
        records: _records.Records.bindScope(client),
        reports: _reports.Reports.bindScope(client),
    };
}
export function createDownloadsApiClient(config) {
    return createClient({
        ...config,
        errorRegistry: _errorsModule.DownloadsApiErrors.DownloadsApiErrorRegistry,
        scopes: (client) => createDownloadsApiBindings(client),
    });
}
//# sourceMappingURL=index.js.map